module.exports = __webpack_public_path__ + "portland-nanny-logo.png?e97a747c2d9268c1ffcbd91bdba93b8e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/portland-nanny-logo.png
// module id = 128
// module chunks = 0